import cx from 'classnames';
import * as React from 'react';

import Input from 'components/Input';
import focusNode from 'utils/focusNode';

import './styles/PrependedTextInput.scss';

type Props = {
  prepend: string;
  className: string;
};

class PrependedTextInput extends React.Component<Props> {
  _inputEl?: HTMLInputElement;

  getInputNode = (): HTMLInputElement | undefined => {
    return this._inputEl;
  };

  getValue = () => {
    if (this._inputEl) {
      return this._inputEl.value;
    }

    return 'error';
  };

  handleFocus = () => {
    const inputNode = this.getInputNode();
    if (inputNode) {
      focusNode(inputNode);
    }
  };

  render() {
    return (
      <div className="PrependedTextInput" onFocus={this.handleFocus}>
        <span className="PrependedTextInput-prepend">{this.props.prepend}</span>
        <Input
          {...this.props}
          ref={(el: any) => {
            this._inputEl = el;
          }}
          className={cx('PrependedTextInput-input', this.props.className)}
          type="text"
        />
      </div>
    );
  }
}

export default PrependedTextInput;
